export const getOriginalRootElement = () => document.getElementById('app')
